// extracted by css-extract-rspack-plugin
export default {"statusAvatarBackground":"InProgressCommentIndicator-module__statusAvatarBackground__zA2ZLc4","statusAvatar":"InProgressCommentIndicator-module__statusAvatar__mqxGf4u"};